import React from "react";
import "./index.css";

const OxfordMUNSection = ({
  handleToggle = () => {},
  handleCounsollerToggle = () => {},
}) => {
  return (
    <div className="oxford-wrapper" id="oxford-mun-form">
      <div className="oxford-left">
        <h2>ABOUT OXFORDMUN INDIA 2025</h2>
        <p>
          OxfordMUN India returns to <b>FLAME University, Pune</b>, for its
          second edition raising the bar for what a Model UN can be. Built in
          collaboration with <b>Oxford Global</b>, this conference blends
          academic depth, global mentorship, and cultural celebration into one
          extraordinary experience.
        </p>
        <p>
          With limited committee sizes, expert-led workshops, and powerful
          agendas, delegates are challenged to think critically and lead with
          purpose. Beyond committee, evenings like the <b>Masquerade Eve</b> and{" "}
          <b>Global Village Gala</b> create lifelong memories. Delegates walk
          away with sharpened leadership, communication, and critical thinking
          skills that set them apart in every academic and personal pursuit.
        </p>
        <p>
          Top delegates will receive{" "}
          <b>100% scholarships to the OxfordMUN Home Conference in the UK</b>,
          taking their journey from India to Oxford.
        </p>
        <p>
          <b>WIN 100% SCHOLARSHIP</b>
        </p>
        <p>
          At OxfordMUN India 2025, excellence is recognised and rewarded with
          opportunity. The Best Delegate of each committee will receive a 100
          percent scholarship covering the registration fee for the OxfordMUN
          Home Conference in the United Kingdom. This is a chance to carry your
          voice from the committee rooms at FLAME University to the halls of
          Oxford, representing India on a global stage. The scholarship is not a
          token of victory, but a recognition of thoughtful diplomacy,
          compelling argumentation, and a genuine commitment to global dialogue.
        </p>
      </div>

      <div className="oxford-logo-center">
        <img
          src="/assets/images/OxfordMunNew/OxfordMun2025.svg"
          alt="OxfordMUN"
        />
      </div>

      <div className="oxford-right">
        <h3>HIGHLIGHTS FROM <br/> LAST YEAR</h3>
        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
            marginBottom: "24px",
          }}
        >
          <iframe
            // width="560"
            // height="315"
            src="https://www.youtube-nocookie.com/embed/ywdNacKnw7E?si=MWKpgJk4booKlDaz"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            // allowFullscreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          ></iframe>
        </div>
        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
            marginBottom: "24px",
          }}
        >
          <iframe
            // width="560"
            // height="315"
            src="https://www.youtube-nocookie.com/embed/bHbjVVJTIfo?si=-7zzguNW-cdFocqU"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            // allowFullscreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          ></iframe>
        </div>
        <div className="buttons-section">
          <button className="primary-btn" onClick={handleToggle}>
            REGISTER NOW
          </button>
          <a
            className="secondary-btn"
            href="https://bit.ly/OxfordMUNIndia2025Brochure"
            target="_blank"
          >
            DOWNLOAD BROCHURE
          </a>
          <button className="primary-btn" onClick={handleCounsollerToggle}>CONNECT WITH A COUNSELLOR</button>
        </div>
        {/* <form className="oxford-form">
          <label>
            <p>Name</p>
            <input
              className="bottom-border input-style"
              type="text"
              placeholder="Jack Sullivan"
            />
          </label>
          <label>
            <p>Phone</p>
            <div className="phone-input bottom-border">
              <span>+91</span>
              <input
                className="input-style"
                type="text"
                placeholder="9876543210"
              />
            </div>
          </label>
          <label>
            <p>Email</p>
            <input
              className="bottom-border input-style"
              type="email"
              placeholder="jack.s@email.com"
            />
          </label>
          <label>
            <p>I am a</p>
            <select className="bottom-border input-style">
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </label>
          <label>
            <p>Your School</p>
            <input
              className="bottom-border input-style"
              type="text"
              placeholder="403001"
            />
          </label>
          <label>
            <p>City</p>
            <select className="bottom-border input-style">
              <option>Goa</option>
              <option>Mumbai</option>
              <option>Delhi</option>
            </select>
          </label>
          <button type="submit">Submit</button>
        </form> */}
      </div>
    </div>
  );
};

export default OxfordMUNSection;
